<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-04 16:35:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveBalance\components\viewTransactions.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-11 18:02:12
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_leaveBalance_form_dialog_viewLeaveTransactionTitle')
    "
    :dialog="show"
    width="800"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_leaveTypeLabel")
            }}</v-sheet>
            <v-select
              :items="leaveType"
              :readonly="!isEdited"
              :filled="false"
              append-icon=""
              item-text="leave_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_leaveBalance_form_dialog_leaveTypeLabel')
              "
              v-model="TransactionsData.leave_type_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_transactionTypeLabel")
            }}</v-sheet>
            <v-select
              :readonly="!isEdited"
              :filled="false"
              :items="Transactiontype"
              :disabled="!TransactionsData.leave_type_uuid"
              item-text="leave_transaction_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              append-icon=""
              dense
              :placeholder="
                $t('label_essweb_leaveBalance_form_dialog_transactionTypeLabel')
              "
              v-model="TransactionsData.leave_transaction_type_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col>
          <template v-if="logic_method == 'D'">
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <DateTimePicker
                type="datetime"
                :readonly="!isEdited"
                :filled="false"
                :defaultTime="TransactionsData.start_utc_datetime"
                :max="TransactionsData.end_utc_datetime"
                :rules="$GetRules(['_Require_Rules'], [null])"
                :label="
                  $t(
                    'label_essweb_leaveBalance_form_dialog_leaveStartTimeLabel'
                  )
                "
                @change="(time) => (TransactionsData.start_utc_datetime = time)"
              ></DateTimePicker>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <DateTimePicker
                type="datetime"
                :readonly="!isEdited"
                :filled="false"
                :defaultTime="TransactionsData.end_utc_datetime"
                :min="TransactionsData.start_utc_datetime"
                :rules="$GetRules(['_Require_Rules'], [null])"
                :label="
                  $t('label_essweb_leaveBalance_form_dialog_leaveEndTimeLabel')
                "
                @change="(time) => (TransactionsData.end_utc_datetime = time)"
              ></DateTimePicker>
            </v-col>
            <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
              <v-sheet class="text--secondary">{{
                $t("label_essweb_leaveBalance_form_dialog_timeZoneLabel")
              }}</v-sheet>
              <v-select
                :items="staticZone"
                item-text="text"
                item-value="utc"
                dense
                single-line
                append-icon=""
                v-model="TransactionsData.start_time_time_zone"
                :placeholder="
                  $t('label_essweb_leaveBalance_form_dialog_timeZoneLabel')
                "
                :readonly="!isEdited"
                :filled="false"
              >
                <template v-slot:no-data> <noContent /> </template
              ></v-select>
            </v-col> -->
          </template>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="Number(clientMode) == 1"
          >
            <DateTimePicker
              type="month"
              :readonly="!isEdited"
              :filled="false"
              :defaultTime="TransactionsData.leave_period"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_leaveBalance_form_dialog_leavePeriodLabel')
              "
              @change="(time) => (TransactionsData.leave_period = time)"
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_totalDayHourLabel")
            }}</v-sheet>
            <v-row>
              <v-col md="5">
                <v-text-field
                  dense
                  single-line
                  type="number"
                  :readonly="!isEdited"
                  :filled="false"
                  placeholder="days"
                  v-model="TransactionsData.number_of_day"
                >
                  <template v-slot:append-outer>
                    <div
                      style="width: 40px"
                      class="text-subtitle-1 text-center"
                    >
                      {{ $t("label_essweb_system_dayLabel") }}
                    </div></template
                  >
                </v-text-field>
              </v-col>
              <v-col md="5">
                <v-text-field
                  dense
                  type="number"
                  single-line
                  :readonly="!isEdited"
                  :filled="false"
                  placeholder="hours"
                  v-model="TransactionsData.number_of_minutes"
                >
                  <template v-slot:append-outer>
                    <div
                      style="width: 40px"
                      class="text-subtitle-1 text-center"
                    >
                      {{ $t("label_essweb_system_hourLabel") }}
                    </div></template
                  >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet
              class="white--text rounded-lg pa-3 subtitle-1"
              color="primary"
            >
              <span
                >{{
                  $t("label_essweb_leaveBalance_form_dialog_totalMinutesLabel")
                }}: {{ $get_thousand_num(totalMinute) }}
                {{ $t("label_essweb_system_minutesLabel") }}</span
              >
              <span></span>
            </v-sheet>
          </v-col>
          <v-col
            xs="12"
            sm="6"
            md="6"
            lg="6"
            cols="12"
            v-if="Number(clientMode) == 1"
          >
            <DateTimePicker
              type="date"
              :readonly="!isEdited"
              :filled="false"
              :defaultTime="TransactionsData.effective_utc_datetime"
              :max="TransactionsData.expired_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t(
                  'label_essweb_leaveBalance_form_dialog_effectiveStartDateLabel'
                )
              "
              @change="
                (time) => (TransactionsData.effective_utc_datetime = time)
              "
            ></DateTimePicker>
          </v-col>
          <v-col
            xs="12"
            sm="6"
            md="6"
            lg="6"
            cols="12"
            v-if="Number(clientMode) == 1"
          >
            <DateTimePicker
              type="date"
              :readonly="!isEdited"
              :filled="false"
              :defaultTime="TransactionsData.expired_utc_datetime"
              :min="TransactionsData.effective_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_leaveBalance_form_dialog_expiredDateLabel')
              "
              @change="(time) => (TransactionsData.expired_utc_datetime = time)"
            ></DateTimePicker>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              dense
              append-icon=""
              single-line
              v-model="TransactionsData.effective_time_zone"
              :placeholder="
                $t('label_essweb_leaveBalance_form_dialog_timeZoneLabel')
              "
              :readonly="!isEdited"
              :filled="false"
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveBalance_form_dialog_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="TransactionsData.remarks"
              dense
              counter="500"
              single-line
              :readonly="!isEdited"
              :filled="false"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>-->
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "newTrannsactions",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: [String, Number] },
    staff_uuid: { default: "", type: [String, Number] },
    detailUuid: { default: "", type: [String, Number] },
  },
  computed: {
    ...mapGetters(["staticZone", "defaultUTC", "clientMode"]),
    totalMinute() {
      if (this.logic) {
        return (
          Number(this.TransactionsData.number_of_day) * Number(this.logic) +
          Number(this.TransactionsData.number_of_minutes) * 60
        );
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      leaveType: [],
      isEdited: false,
      logic: null || 0,
      logic_method: null,
      leavePeriod: [],
      Transactiontype: [],
      TransactionsData: {
        leave_type_uuid: "",
        leave_transaction_type_uuid: "",
        start_utc_datetime: "",
        start_time_time_zone: "",
        end_utc_datetime: "",
        end_time_time_zone: "",
        leave_period: "",
        number_of_day: 0,
        effective_time_zone: "",
        number_of_minutes: 0,
        time_zone: "480",
        effective_utc_datetime: "",
        expired_utc_datetime: "",
        leave_start_date: "",
        leave_end_date: "",
        leave_time_zone: "480",
        remarks: "",
      },
    };
  },
  watch: {
    detailUuid(val) {
      if (val) this.getDetail(val);
      if (!val && this.$refs["form"]) this.$refs["form"].reset();
      this.TransactionsData.number_of_day = 0;
      this.TransactionsData.number_of_day = 0;
    },
    "TransactionsData.number_of_day": function (v) {
      // console.log(v);
    },
    "TransactionsData.leave_type_uuid": function (val) {
      if (this.isEdited) this.TransactionsData.transaction_type = "";
      if (val) {
        if (this.isEdited) {
          this.TransactionsData.start_utc_datetime = "";
          this.TransactionsData.end_utc_datetime = "";
          this.TransactionsData.number_of_day = 0;
          this.TransactionsData.number_of_day = 0;
        }
        this.getTransactionType(val);
      }
    },
    "TransactionsData.leave_transaction_type_uuid": function (val) {
      if (this.isEdited) {
        let obj = this.Transactiontype.find((ele) => ele.uuid === val);
        if (obj) this.logic_method = obj["calculation_method"];
        if (val) {
          this.TransactionsData.start_utc_datetime = "";
          this.TransactionsData.end_utc_datetime = "";
          this.TransactionsData.number_of_day = 0;
          this.TransactionsData.number_of_day = 0;
        }
      }
    },
  },
  mounted() {
    this.TransactionsData.time_zone = this.defaultUTC;
    this.TransactionsData.start_time_time_zone = this.defaultUTC;
    this.TransactionsData.end_time_time_zone = this.defaultUTC;
    this.TransactionsData.leave_time_zone = this.defaultUTC;
    this.getLogic();
    this.getLeaveType();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getLogic: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "hehe",
        url: "/other/get-standard-working-minutes/",
        data: { staff_uuid: this.staff_uuid },
      }).then((res) => {
        that.logic = res.data;
      });
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_record",
        url: "/leave-transaction-record/get-details/",
        data: { uuid: uuid },
      }).then((res) => {
        if (res.data["leave_period"])
          res.data["leave_period"] =
            res.data["leave_period"].toString().substring(0, 4) +
            "-" +
            res.data["leave_period"].toString().substring(4, 6);
        res.data["start_utc_datetime"] = this.$getDateTime(
          res.data["start_utc_datetime"],
          "YYYY-MM-DD HH:mm"
        );
        res.data["end_utc_datetime"] = this.$getDateTime(
          res.data["end_utc_datetime"],
          "YYYY-MM-DD HH:mm"
        );
        res.data["effective_utc_datetime"] = this.$getDateTime(
          res.data["effective_utc_datetime"],
          "YYYY-MM-DD"
        );
        res.data["expired_utc_datetime"] = this.$getDateTime(
          res.data["expired_utc_datetime"],
          "YYYY-MM-DD"
        );
        res.data["number_of_minutes"] =
          Number(res.data["number_of_minutes"]) / 60;
        that.TransactionsData = res.data;
      });
    },
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.leave_type_name = that.$getCommonLangValue(item.leave_type_name);
        });
        that.leaveType = res.data;
      });
    },
    getTransactionType: function (val) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type",
        url: "/leave-transaction-type/get-list/",
        data: {
          leave_type_uuid: val,
          //  add_support_type_filter: 1 //查看不传
        },
      }).then((res) => {
        res.data.map((item) => {
          item.leave_transaction_type_name = that.$getCommonLangValue(
            item.leave_transaction_type_name
          );
        });
        that.Transactiontype = res.data;
      });
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let data = {
        staff_uuid: this.curUuid,
        leave_type_uuid: this.TransactionsData.leave_type_uuid,
        leave_transaction_type_uuid:
          this.TransactionsData.leave_transaction_type_uuid,
        leave_period: dayjs(this.TransactionsData.leave_period).format(
          "YYYYMM"
        ),
        number_of_day: this.TransactionsData.number_of_day,
        number_of_minutes: Number(this.TransactionsData.number_of_minutes) * 60,
        total_minutes: this.totalMinute,
        effective_utc_datetime: this.$getTimeValue(
          this.TransactionsData.effective_utc_datetime
        ),
        effective_time_zone: this.TransactionsData.time_zone,
        expired_utc_datetime: this.$getTimeValue(
          this.TransactionsData.expired_utc_datetime
        ),
        expired_time_zone: this.TransactionsData.time_zone,
        remarks: this.TransactionsData.remarks,
      };
      if (this.logic_method == "D") {
        data["start_utc_datetime"] = this.$getTimeValue(
          this.TransactionsData.start_utc_datetime
        );
        data["end_utc_datetime"] = this.$getTimeValue(
          this.TransactionsData.end_utc_datetime
        );
        data["start_time_time_zone"] =
          this.TransactionsData.start_time_time_zone;
        data["end_time_time_zone"] = this.TransactionsData.start_time_time_zone;
      }
      this.$emit("onNew", data);
    },
  },
};
</script>
